import styled from 'styled-components';

export const SplashesStyle = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 99999999999999;
  background: white;
  position: fixed;
  img {
    max-width: 220px;
  }
`;
